<template>
    <v-container fluid class="my-0 py-0">
        <filters :cup="true" @getRankingByLeague="getRankingByLeague" @getRankingByTeam="getRankingByTeam" @getCupState="getCupState" @clear="clearData" />
        <v-row>
            <v-col cols="12">
                <standings-table v-if="!showBracket" :ranking="ranking" :loading="loading" class="standings-page-table" />
                <!-- the bracket made in the CMS; the playoffs of a league without one: the picture of its standings -->
                <bracket-board v-else-if="bracketLoaded" :bracket="bracket" @match="openMatch" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import Filters from '@/components/GenericFilters'
    import teamService from '@/services/team'
    import leagueService from '@/services/league.js'
    import BracketBoard from '@/components/BracketBoard'
    import bracketService from '@/services/bracket'
    import StandingsTable from '@/components/StandingsTable'
    import { prepareRanking } from '@/utils/standings'

    export default {
        components: { Filters, BracketBoard, StandingsTable },
        data() {
            return {
                ranking: [],
                type: 'regular_season',
                bracket: null,
                bracketLoaded: false,
                bracketRequest: null,
                // the ranking of the latest choice only
                rankingRequest: 0,
                loading: false
            }
        },
        computed: {
            showBracket() {
                return this.type === 'cup' || this.type === 'playoffs'
            }
        },
        methods: {
            // another season: nothing on screen until its data comes
            clearData() {
                this.rankingRequest++
                this.bracketRequest = null
                this.ranking = []
                this.bracket = null
                this.bracketLoaded = false
                this.loading = false
            },
            getCupState(isCup, leagueId, seasonId) {
                this.type = isCup ? 'cup' : 'playoffs'
                this.bracket = null
                this.bracketLoaded = false
                const request = { seasonId, leagueId, cup: isCup }
                const requestKey = JSON.stringify(request)
                this.bracketRequest = requestKey
                bracketService.getBracket(request).then(resp => {
                    // only the answer of the latest choice
                    if (this.bracketRequest === requestKey) {
                        this.bracket = resp.data || null
                        this.bracketLoaded = true
                    }
                }).catch(() => {
                    if (this.bracketRequest === requestKey) {
                        this.bracketLoaded = true
                    }
                })
            },
            openMatch(matchId) {
                this.$router.push(`/Match/${matchId}`)
            },
            getRankingByTeam(teamId, type) {
                this.type = type || 'regular_season'
                this.loading = true
                const request = ++this.rankingRequest
                teamService.getRankingByTeam(teamId, type).then(resp => {
                    if (request === this.rankingRequest) this.ranking = prepareRanking(resp.data)
                }).finally(() => {
                    if (request === this.rankingRequest) this.loading = false
                })
            },
            getRankingByLeague(leagueId, seasonId, type) {
                this.type = type || 'regular_season'
                this.loading = true
                const request = ++this.rankingRequest
                leagueService.getRankingByLeague(leagueId, seasonId, type).then(resp => {
                    if (request === this.rankingRequest) this.ranking = prepareRanking(resp.data)
                }).finally(() => {
                    if (request === this.rankingRequest) this.loading = false
                })
            }
        }
    }
</script>

<style scoped>
/* Same width as the filters bar and the match center */
.standings-page-table {
    max-width: 1200px;
    margin: 0 auto;
}
</style>
